import {combineReducers} from 'redux';
import {localizeReducer} from 'react-localize-redux';
import layoutReducer from '../../features/Layout/reducers';
import errorReducer from '../../features/Errors/reducers';
import authReducer from '../../features/Auth/reducers';
import contentReducer from '../../features/Content/reducers';
import contactReducer from '../../features/Contact/reducers';
import schoolsReducer from '../../features/Schools/reducers';
import eventsReducer from '../../features/Events/reducers';
import newsReducer from '../../features/News/reducers';
import institutionsReducer from '../../features/Institutions/reducers';
import dashboardReducer from '../../features/Dashboard/reducers';


export default combineReducers({
    localize: localizeReducer,
    layout: layoutReducer,
    errors: errorReducer,
    auth: authReducer,
    content: contentReducer,
    contact: contactReducer,
    schools: schoolsReducer,
    events: eventsReducer,
    news: newsReducer,
    institutions: institutionsReducer,
    dashboard: dashboardReducer,
});



// WEBPACK FOOTER //
// ./src/app/redux/reducers.js